
import Vue, { PropType } from 'vue';
import type { AppBarTab } from '@/types';

import { VSpacer } from 'vuetify/lib';

import LanguageSwitcher from '@/components/ui/LanguageSwitcher.vue';

export default Vue.extend({
  name: 'AppBar',

  components: {
    VSpacer,
    LanguageSwitcher,
  },

  props: {
    tabs: {
      type: Array as PropType<AppBarTab[]>,
      required: false,
      default: () => [],
    },
  },
});
